import { GridRenderCellParams, GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';
import { NumberFormatPreset, UseCurrencyProps, useCurrency } from '@procureai/ui-mui';

import { DecimalTextFieldCell } from '../DecimalTextFieldCell/DecimalTextFieldCell';
import { DefaultDataEditGridConfig } from '~/components/DataGridCustom';

interface CurrencyCellProps<R extends GridValidRowModel>
  extends GridRenderCellParams<R>, UseCurrencyProps, DefaultDataEditGridConfig {
  preset?: NumberFormatPreset;
  decimalScale?: number;
}

export const CurrencyCell = <R extends GridValidRowModel & { id: GridRowId } = { id: GridRowId }>(
  props: CurrencyCellProps<R>,
) => {
  const { symbol } = useCurrency(props);

  return <DecimalTextFieldCell {...props} prefix={symbol} />;
};
